module.exports = __webpack_public_path__ + "static/media/debitCard.d934e457.jpg";